import clsx from 'clsx'
import dayjs from 'dayjs'

import { useModal } from '@/shared/hooks/use-modal'
import { formatMinutesToHours, formattedBalance } from '@/shared/lib/formatters'
import { BottomSheet, Button } from '@/shared/ui'

import { AboutTransaction } from '@/entities/about-transaction'

import styles from './transaction.module.scss'

import 'dayjs/plugin/calendar'

import { AchievementImg } from '@/assets'

type TTransaction = {
    amount_cents: number // сумма в копейках (целое число, отрицательное для списаний)
    balance_cents?: number // баланс после операции в копейках (необязательно)
    comment?: string // комментарий, например "С комиссией $service_name$"
    currency: string // валюта, например "RUB"
    description: string // описание операции, например "Доход с заказа"
    duration_minutes?: number // только если есть длительность в описании
    status: 'completed' | 'processing' // статус: завершена или в обработке
    timestamp: string // ISO 8601 UTC, например "2026-01-20T14:32:00Z"
}

export const Transaction = ({ transaction }: { transaction: TTransaction }) => {
    const { isModalOpen, openModal, closeModal, closeHandlerReady } = useModal()
    const {
        isModalOpen: isModalOpenAchievement,
        openModal: openModalAchievement,
        closeModal: closeModalAchievement,
        closeHandlerReady: closeHandlerReadyAchievement,
    } = useModal()

    return (
        <>
            <button
                className={styles['transaction']}
                type='button'
                onClick={
                    transaction.description === 'Достижение цели' ? openModalAchievement : openModal
                }
            >
                <span className={styles['transaction__date']}>
                    {dayjs(transaction.timestamp).calendar(null, {
                        sameDay: '[сегодня в] HH:mm',
                        lastDay: '[вчера в] HH:mm',
                        lastWeek: 'DD.MM [в] HH:mm',
                        sameElse: 'DD.MM [в] HH:mm',
                    })}
                </span>
                <div className={styles['transaction-description']}>
                    <span className={styles['transaction-description__text']}>
                        {transaction.description}
                        {transaction.status === 'processing' && (
                            <>
                                {' '}
                                (
                                <span
                                    className={styles['transaction-description__text--processing']}
                                >
                                    {transaction.duration_minutes ?
                                        formatMinutesToHours(transaction.duration_minutes)
                                    :   'в обработке'}
                                </span>
                                )
                            </>
                        )}
                    </span>
                    <div
                        className={clsx(
                            styles['transaction-description__amount'],
                            (
                                transaction.status === 'processing' &&
                                    transaction.amount_cents > 0 &&
                                    transaction.duration_minutes
                            ) ?
                                styles['transaction-description__amount--processing']
                            :   transaction.amount_cents > 0 &&
                                    transaction.status === 'completed' &&
                                    styles['transaction-description__amount--positive'],
                        )}
                    >
                        {transaction.amount_cents > 0 && '+'}
                        {formattedBalance(transaction.amount_cents.toString())[0]}
                        <span className={styles['transaction-description__amount--decimal']}>
                            ,{formattedBalance(transaction.amount_cents.toString())[1]}
                            &nbsp;
                        </span>
                        {transaction.currency === 'RUB' ? '₽' : ''}
                    </div>
                </div>
                <div className={styles['transaction-description__balance']}>
                    {transaction.balance_cents && (
                        <>
                            <span>{transaction.comment ?? 'До вычета'}</span>
                            <span>
                                {formattedBalance(transaction.balance_cents.toString())[0]},
                                {formattedBalance(transaction.balance_cents.toString())[1]}{' '}
                                {transaction.currency === 'RUB' ? '₽' : ''}
                            </span>
                        </>
                    )}
                </div>
            </button>
            {isModalOpen && (
                <BottomSheet
                    withoutHeader
                    closeHandlerReady={closeHandlerReady}
                    onClose={closeModal}
                >
                    <AboutTransaction />
                </BottomSheet>
            )}
            {isModalOpenAchievement && (
                <BottomSheet
                    closeHandlerReady={closeHandlerReadyAchievement}
                    onClose={closeModalAchievement}
                >
                    <div className={styles['achievement']}>
                        <img alt='' className={styles['achievement__img']} src={AchievementImg} />
                        <span className={styles['achievement__title']}>
                            +5 000 ₽ за достижение цели
                        </span>
                        <span className={styles['achievement__description']}>
                            Вы выполнили цель: совершить{' '}
                            <span className={styles['achievement__description--bold']}>
                                50 поездок
                            </span>{' '}
                            с 24 по 31 декабря
                        </span>
                        <Button size='large' variant='primary'>
                            Отлично
                        </Button>
                    </div>
                </BottomSheet>
            )}
        </>
    )
}
